
function ty_param() {
    var qs = window.location.href.split('?');
    return (qs.length == 2 && qs[1].indexOf("ty=1") !== -1)
}

function add_local_to_links(){
  const locale = window.location.href.split('/')[3]
  if(locale == 'pages') return;

  let elements = document.getElementsByClassName('smoothie-link');
  for(let element of elements){
    const href = element.getAttribute("href");
    element.setAttribute("href", '/' + locale + href);
  }
}

function addPageUrl(){
  const parts = window.location.href.split('/')
  let i=0;
  for(; i<parts.length; i++){
    if(parts[i] == "pages") break ;
  }
  const page_url = '/' + parts[i] + '/' + parts[i + 1];
  document.getElementById('smoothie-hidden-page-url').setAttribute("value", page_url)
}

window.smoothScroll = function(target) {
    console.log('new scroll 2')
    var self = this
    this.scrollContainer = target;
    do { //find scroll container
        self.scrollContainer = self.scrollContainer.parentNode;
        if (!self.scrollContainer) return;
        self.scrollContainer.scrollTop += 1;
    } while (self.scrollContainer.scrollTop == 0);

    this.targetY = 0;
    do { //find the top of target relatively to the container
        if (target == self.scrollContainer) break;
        self.targetY += target.offsetTop;
    } while (target = target.offsetParent);

    let scrollFuncInner = function(c, a, b, i) {
        i++; if (i > 30) return;
        c.scrollTop = a + (b - a) / 30 * i;
        setTimeout(function(){ scrollFuncInner(c, a, b, i); }, 20);
    }
    // start scrolling
    scrollFuncInner(self.scrollContainer, self.scrollContainer.scrollTop, self.targetY, 0);
}


document.onreadystatechange = function (){
    if (document.readyState == "interactive") {
        // Initialize your application or run some code.
        if(ty_param()){
          document.getElementById("smoothie-job-content").className = "thank-you"
          console.log("Thank you")
        }

        add_local_to_links()

        addPageUrl()

        document.getElementById("resume").onchange = function() {
            var mb = 4;
            if(this.files[0].size > (1048576*mb) ){
               alert("File is too big! Please upload a file smaller than "+String(mb)+"MB");
               this.value = "";
            };
        };
    }
}

if ($(window).width() < 768) {
$(".slick-slider2").slick({
slidesToShow: 2,
infinite:false,
slidesToScroll: 2,
autoplay: false,
arrows: true
});
}



// =======================
class LoadMore extends HTMLElement { 
  constructor(){
    super();
    this.addEventListener("click", this.loadMoreItems);
  }

  loadMoreItems() { 
   
    const loadMoreBtn = this.querySelector('[type="button"]');
    loadMoreBtn.setAttribute("disabled", true);

    let { currentPage, pageSize, nextUrl, totalItems } = this.dataset
    let nextPage = parseInt(this.dataset.currentPage) + 1
    
    fetch(nextUrl.replace(/page=[0-9]+/,'page='+ nextPage))
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        $('#main-collection-product-grid').append($(html).find('#main-collection-product-grid').html());
      }).catch((e) => {
        // handle error
        console.error(e);
      })
      .finally(() => {
        loadMoreBtn.removeAttribute("disabled");
        this.dataset.currentPage = parseInt(this.dataset.currentPage) + 1;
        
        let isLastPage = parseInt(totalItems) - (nextPage * parseInt(pageSize) ) < 0
        this.querySelector('[load-items-count]').innerHTML = isLastPage ? parseInt(totalItems) : nextPage * parseInt(pageSize)
        isLastPage && loadMoreBtn.setAttribute("disabled", true);
      });
  }
}

customElements.define('load-more', LoadMore);